import React from 'react';
import { routes } from '../../config/utility';
import { Link } from 'react-router-dom';
import { faFacebookF, faInstagram, faTiktok, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = ({ isSidebarOpen, roles }) => {
    return (
        <footer className={`backdrop-blur-lg bg-transparent fixed bottom-0 w-full px-4 py-2 sm:px-6 sm:py-3
            flex flex-row items-center justify-between transition-all sm:ml-4 text-xs sm:text-sm
            ${isSidebarOpen ? 'sm:w-[calc(100%-18rem)]' : 'sm:w-[calc(100%-6rem)]'}`}>

            {/* Left Section - Links (Hidden on mobile) */}
            <div className="hidden sm:flex justify-start gap-4">
                <Link to={routes.terms} className="text-tblue hover:underline transition duration-200">
                    Terms & Conditions
                </Link>
                <span>|</span>
                <Link to={routes.privacy_policy} className="text-tblue hover:underline transition duration-200">
                    Privacy Policy
                </Link>
                <span>|</span>
                <Link to={routes.eula} className="text-tblue hover:underline transition duration-200">
                    License Agreement
                </Link>
                <span>|</span>
                <Link to='https://mypawdash.com/contact' target='_blank' className="text-tblue hover:underline transition duration-200">
                    Contact
                </Link>
            </div>


            {roles.includes('user') && (
                <></>
            )}
            {/* Mobile View - Simplified Layout */}
            <div className="flex sm:hidden items-center gap-1">
                <span className="text-tblue font-bold">© {new Date().getFullYear()} </span>

                <span className="text-tblue">•</span>
                <Link to={routes.terms} className="text-tblue hover:underline">Terms</Link>
                <span className="text-tblue">•</span>
                <Link to={routes.privacy_policy} className="text-tblue hover:underline">Privacy</Link>
                <span className="text-tblue">•</span>
                <Link to={routes.eula} className="text-tblue hover:underline">L&A</Link>
                <span className="text-tblue">•</span>
                <Link to="https://mypawdash.com/contact" className="text-tblue hover:underline">Contact</Link>

            </div>

            {/* Copyright - Desktop Only */}
            <div className="hidden sm:block font-bold text-tblue">
                © {new Date().getFullYear()} PawDash Inc.
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-3">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-tblue hover:text-blue-500 transition" title="Facebook (Coming Soon)">
                    <FontAwesomeIcon icon={faFacebookF} className="text-xs sm:text-sm" />
                </a>
                <a href="https://www.instagram.com/pawdash.ae?igsh=dG53OWhncnRnaXJ3&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-tblue hover:text-pink-500 transition" title="Follow us on Instagram">
                    <FontAwesomeIcon icon={faInstagram} className="text-xs sm:text-sm" />
                </a>
                <a href="https://www.tiktok.com/@pawdash?_t=ZS-8yZFdEVjBWT&_r=1" target="_blank" rel="noopener noreferrer" className="text-tblue hover:text-black transition" title="Follow us on TikTok">
                    <FontAwesomeIcon icon={faTiktok} className="text-xs sm:text-sm" />
                </a>
            </div>

        </footer>
    );
};

export default Footer;